import React from 'react'
import { Dropdown } from 'react-bootstrap'
import EditModal from './EditModal'
import DeleteModal from './DeleteModal'
import { IDictionaryItem } from '../../../../types/IDictionaryItem'

type Props = {
    item: IDictionaryItem,
    update: () => void
}

const OperationList = (props: Props) => {
    return <Dropdown>
        <Dropdown.Toggle variant="light" id="dropdown-basic">
            <i className="fa-solid fa-ellipsis-vertical"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <EditModal item={props.item} update={props.update} />
            <DeleteModal item={props.item} update={props.update} />
        </Dropdown.Menu>
    </Dropdown>
}

export default OperationList